// src/components/PublicRoute.jsx

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PublicRoute() {
  const { isAuthenticated, initialized } = useAuth();

  if (!initialized) {
    return null;
  }

  return isAuthenticated
    ? <Navigate to="/dashboard" replace />
    : <Outlet />;
}
